import { Route } from "react-router-dom"
import { pagesUrl } from "@app/core/appConstants"
import { withoutAppSideBar } from "@app/core/context/AppSideBarContext/AppSideBarContext"

export const RseeRoutes = (
  // A document's screens take the whole screen: no side bar.
  <Route
    handle={withoutAppSideBar}
    lazy={() => import("./RseeRouteLayout").then((module) => ({ Component: module.RseeRouteLayout }))}>
    <Route
      path={pagesUrl.BEEM_PILOT_UPLOAD_PAGE}
      lazy={() =>
        import("@app/pages/projects/project/beem-pilot/pages/RseeUploadPage").then((module) => ({
          Component: module.RseeUploadPage,
        }))
      }
    />
    <Route
      path={pagesUrl.BEEM_PILOT_DOCUMENT_DETAIL_PAGE}
      lazy={() =>
        import("@app/pages/projects/project/beem-pilot/pages/RseeDocumentDetailPage").then((module) => ({
          Component: module.RseeDocumentDetailPage,
        }))
      }
    />
  </Route>
)
